import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useGlobalStore } from '@/state/global.state';
import { color } from '@/colors';
import { I18N_KEYS } from '@/language/keys';
import { ZIndex } from '@/consts/z-indexes.consts';
import { FlexCenHorVer } from '../styles';
import { ButtonContained } from '../Buttons/AppButton';
import { InfoIcon } from '../Icons';

interface ReloadAlertStandaloneProps {
  message: string;
  ctaText: string;
  onRefresh: () => void;
}

export const ReloadAlertStandalone = ({ message, ctaText, onRefresh }: ReloadAlertStandaloneProps) => (
  <FlexCenHorVer
    sx={{
      position: 'fixed',
      inset: 0,
      backgroundColor: color.Black84_T,
      zIndex: ZIndex.Overlays.CRITICAL_SYSTEM_ALERT,
    }}
  >
    <FlexCenHorVer
      sx={{
        height: 40,
        backgroundColor: color.Yellow64,
        borderRadius: 1,
        pl: 1.5,
        py: 1.75,
        pr: 1,
      }}
    >
      <InfoIcon style={{ width: 20, height: 20, marginRight: '8px' }} color={color.Black100} />
      <Typography variant="body-sm-rg" color={color.Black100} mr={2}>
        {message}
      </Typography>
      <ButtonContained mode="text" onClick={onRefresh} sx={{ fontSize: '0.75rem', color: color.Black100 }}>
        {ctaText}
      </ButtonContained>
    </FlexCenHorVer>
  </FlexCenHorVer>
);

export const ReloadAlert = () => {
  const isShowRefreshAlert = useGlobalStore((state) => state.isShowRefreshAlert);
  const { t } = useTranslation();
  if (!isShowRefreshAlert) {
    return null;
  }

  return (
    <ReloadAlertStandalone
      message={t(I18N_KEYS.GENERAL.RELOAD_ALERT_TITLE)}
      ctaText={t(I18N_KEYS.GENERAL.RELOAD_ALERT_CTA)}
      onRefresh={() => window.location.reload()}
    />
  );
};
